import React, { Fragment, useState, useEffect } from "react";
import { Row, Col, Form, Button,Toast } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { IoIosClose, IoMdDownload } from "react-icons/io";
import ReactTable from "../../../components/FilterTable";
import { _HttpServices } from "../../../_services/_HttpServices";
import Loader from "../../../components/Loader";
// import Loader from "../../components/Loader";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { useHistory } from 'react-router';
import getExcel from "../../../_services/ExcelUtility";
import { Footer } from "../../../components/Footer";
const AptevoSalesSourcePage = () => {
    const outbounddata = JSON.parse(localStorage.getItem("outboundreport"));
    const userData = JSON.parse(localStorage.getItem('userData'));
    const history = useHistory();
    const fileName = 'Sales Source Data';
    const [salesSource, setSalesSource] = useState([]);
    const [loading, setLoading] = useState(false);
    // const [showToaster, setShowToaster] = useState(false);
    // let Message;
    const [hasError, setHasError] = useState(false);
    const columns = [

        {
            Header: "Distributor Name",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "Distribution Location State",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
        },
        {
            Header: "Report Date",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        //  {
        //     Header: "Debit Memo#",
        //     accessor: "DebitMemo",
        //     filter: "DebitMemo",
        //     sortType: "basic",
        // }, 
        // {
        //     Header: "Cust PHS ID",
        //     accessor: "CustPHSID",
        //     filter: "CustPHSID",
        //     sortType: "basic",
        // },
        {
            Header: "CB Cust PHS ID# (For applicable CBs only)",
            accessor: "CustPHSID",
            filter: "CustPHSID",
            sortType: "basic",
        },
        {
            Header: " CB Cust Name",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
        },
        {
            Header: "CB Cust Address",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
        },
        {
            Header: "CB Cust City",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
        },
        {
            Header: "CB Cust State",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
        },
        {
            Header: "CB Cust Zip",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
        },
        {
            Header: "CB Customer's Invoice #",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "CB Customer's Invoice Date",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "Contract Reference",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
        {
            Header: "Product NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "Product Description",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
        },
        {
            Header: "Sale QTY",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
        },
        {
            Header: "Sale  QTY UOM",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
        }, {
            Header: "DOSAGE/UNITS",
            accessor: "DosagORUnits",
            filter: "DosagORUnits",
            sortType: "basic",
        },
        {
            Header: "Dosage/Units UOM",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
        },
        {
            Header: "IUs",
            accessor: "IUs",
            filter: "IUs",
            sortType: "basic",
        },
        {
            Header: "Acquisition Cost Per IU/EU/Gram ",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",
            // Cell: ({ row: { original } }) => (
            //     <Fragment>
            //         {original.AcquisitionCost == null ? "$0.00" : <span>$ {(original.AcquisitionCost * 1).toFixed(2)}</span>}
            //     </Fragment>
            // )
        }, {
            Header: "Contract Price Per IU/EU/Gram ",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",
            // Cell: ({ row: { original } }) => (
            //     <Fragment>
            //         {original.ContractPrice == null ? "$0.00" : <span>$ {(original.ContractPrice * 1).toFixed(2)}</span>}
            //     </Fragment>
            // )
        },
        {
            Header: "Customer Extended Amount",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",
            // Cell: ({ row: { original } }) => (
            //     <Fragment>
            //         {original.CIBDExtendedAmount == null ? "$0.00" : <span>$ {(original.CIBDExtendedAmount * 1).toFixed(2)}</span>}
            //     </Fragment>
            // )
        },
        // {
        //     Header: "2% ServiceFees",
        //     accessor: "TwoPercentServiceFees",
        //     filter: "TwoPercentServiceFees",
        //     sortType: "basic",
        // }
    ];

    // excel Headers
    const excelColumns = [

        {
            Header: "DISTRIBUTOR NAME",
            accessor: "DistributorName",
            filter: "DistributorName",
            sortType: "basic",
        },
        {
            Header: "DISTRIBUTION LOCATION STATE",
            accessor: "DistributionLocationState",
            filter: "DistributionLocationState",
            sortType: "basic",
        },
        {
            Header: "REPORT DATE",
            accessor: "ReportDate",
            filter: "ReportDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
       
        {
            Header: "CB CUST PHS ID# (For applicable CBs only)",
            accessor: "CustPHSID",
            filter: "CustPHSID",
            sortType: "basic",
        },
        {
            Header: "CB CUST NAME",
            accessor: "CustName",
            filter: "CustName",
            sortType: "basic",
        },
        {
            Header: "CB CUST ADDRESS",
            accessor: "CustAddress",
            filter: "CustAddress",
            sortType: "basic",
        },
        {
            Header: "CB CUST CITY",
            accessor: "CustCity",
            filter: "CustCity",
            sortType: "basic",
        },
        {
            Header: "CB CUST STATE",
            accessor: "CustState",
            filter: "CustState",
            sortType: "basic",
        },
        {
            Header: "CB CUST ZIP",
            accessor: "CustZip",
            filter: "CustZip",
            sortType: "basic",
        },
        {
            Header: "CB CUSTOMER'S INVOICE#",
            accessor: "CustomersInvoice",
            filter: "CustomersInvoice",
            sortType: "basic",
        },
        {
            Header: "CB CUSTOMER'S INVOICE DATE",
            accessor: "CustomersInvoiceDate",
            filter: "CustomersInvoiceDate",
            sortType: "basic",
            filterMethod: (filter, row) => {
                const rowValue = row.original
                return rowValue.datefiled.includes(filter.value)
            }
        },
        {
            Header: "CONTRACT REFERENCE",
            accessor: "ContractReference",
            filter: "ContractReference",
            sortType: "basic",
        },
        {
            Header: "PRODUCT NDC-11",
            accessor: "ProductNDC",
            filter: "ProductNDC",
            sortType: "basic",
        },
        {
            Header: "PRODUCT DESCRIPTION",
            accessor: "ProductDescription",
            filter: "ProductDescription",
            sortType: "basic",
        },
        {
            Header: "SALE QTY",
            accessor: "SaleQTY",
            filter: "SaleQTY",
            sortType: "basic",
        },
        {
            Header: "SALE QTY UOM",
            accessor: "SaleQTYUOM",
            filter: "SaleQTYUOM",
            sortType: "basic",
        }, {
            Header: "DOSAGE / UNITS",
            accessor: "DosagORUnitstabs30",
            filter: "DosagORUnitstabs30",
            sortType: "basic",
        },
        {
            Header: "DOSAGE / UNITS UOM",
            accessor: "DosageORUnitsUMO",
            filter: "DosageORUnitsUMO",
            sortType: "basic",
        },
        {
            Header: "IUs",
            accessor: "Totalcount",
            filter: "Totalcount",
            sortType: "basic",
        },
        {
            Header: "ACQUISITION COST per IU/EU/Gram",
            accessor: "AcquisitionCost",
            filter: "AcquisitionCost",
            sortType: "basic",
            
        }, {
            Header: "CONTRACT PRICE per IU/EU/Gram",
            accessor: "ContractPrice",
            filter: "ContractPrice",
            sortType: "basic",

        },
        {
            Header: "Customer Extended Amount",
            accessor: "CIBDExtendedAmount",
            filter: "CIBDExtendedAmount",
            sortType: "basic",
         
        },
    ];
    //
    useEffect(() => {
        getServiceFee();
    }, [])
    async function getServiceFee() {
        setLoading(true);
        let url = `api/Inbound/OutboundReportsData?FileProcessID=${outbounddata.FileProcessID}&ServiceTaskID=${outbounddata.ServiceTaskID}&FileTypeCode=${outbounddata.FileTypeCode}&TaskTypeCode=${outbounddata.TaskTypeCode}`;
        await _HttpServices
            // .getData(`api/inbound/AptevoSalesSourceData?fileprocessId=1489=${outbounddata.File_Process_ID}`)
            // .getData(`api/inbound/AptevoSalesSourceData?fileprocessId=${outbounddata.File_Process_ID}`)
            .getData(url)
            .then((data) => {
                const serviceFeeResult = data.data;
                if (serviceFeeResult.length > 0) {
                    serviceFeeResult.map((res) => {
                        res.ReportDate = moment(res.ReportDate).format('MM/DD/YYYY');
                        res.CustomersInvoiceDate = moment(res.CustomersInvoiceDate).format('MM/DD/YYYY');                          
                        res.AcquisitionCost = res.AcquisitionCost == null ? "$0.00" :"$"+ (res.AcquisitionCost * 1).toFixed(2);
                        res.ContractPrice = res.ContractPrice == null ? "$0.00" :"$"+ (res.ContractPrice * 1).toFixed(2);
                        res.CIBDExtendedAmount = res.CIBDExtendedAmount == null ? "$0.00" :"$"+ (res.CIBDExtendedAmount * 1).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                        res.SaleQTY = res.SaleQTY == null? "0.0000":  (res.SaleQTY*1).toFixed(4);
                        res.DosagORUnitstabs30 = res.DosagORUnitstabs30 == null? "0.0000":  (res.DosagORUnitstabs30*1).toFixed(4);
                        res.Totalcount = res.Totalcount == null? "0.0000":  (res.Totalcount*1).toFixed(4);
                    })
                }
                setSalesSource(serviceFeeResult);
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // Message = e.response.data.Message;
                // setShowToaster(true);
                setHasError(true);
            });

    }
    async function headerData(salesSource) {
        var data_to_download = []
        if(salesSource.length != 0){
        salesSource.map((data, pidex) => {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = salesSource[pidex][excelColumns[cindex].accessor]
            })
            data_to_download.push(record_to_download)
        })}
        else {
            let record_to_download = {}
            excelColumns.map((col, cindex) => {
                record_to_download[excelColumns[cindex].Header] = ""
            })
            data_to_download.push(record_to_download)
        }
        exportToCSV(data_to_download)
    }
    const exportToCSV = (data_to_download) => {
        var wscols = [{ wch: 20, color: 'aabbcc' }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }, { wch: 20 }, { wch: 20 }];
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const ws = XLSX.utils.json_to_sheet(data_to_download);
        ws["!cols"] = wscols;
        
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, "Sales Source Data");
    }
    const EditRecords = () =>{
        localStorage.setItem("salesSource",JSON.stringify(salesSource));
        history.push("/AptevoSalesEdit")
    }
    return (
        <section className="content">
            <div className="page-title">
                <h2 className="h2">Sales Source Data</h2>
                {loading ? <Loader /> : null}
                <div>
                {salesSource.length > 0 &&userData.RoleID === 1 &&
                 (outbounddata.FileSentStatus == "Sent" ? <Button type="submit" onClick={() =>EditRecords()}>Create Reversal</Button> :
                    <Button type="submit" onClick={() =>EditRecords()}>Edit Records</Button>
                    )}
                <Button type="submit" className="ml-2" onClick={() => getExcel(excelColumns,salesSource,fileName)}><IoMdDownload className="icon btn-icon" />Download Excel </Button>
                </div>
            </div>
             {/* Toaster */}
             {/* <Toast onClose={() => setShowToaster(false)} show={showToaster} delay={1500} autohide className="custom-toaster">
                <Toast.Header>
                    <img
                        src="holder.js/20x20?text=%20"
                        className="rounded mr-2"
                        alt=""
                    />
                    <strong className="mr-auto">Woohoo!!</strong>
                </Toast.Header>
                <Toast.Body>{Message}</Toast.Body>
            </Toast> */}
            <Row>
                <Col md={12}>
                    <div className="card pt-2 mb-4">
                        <div className="card-body">
                            <div className="inventory-grid">
                            {hasError ? <p>Error occurred. Unable to load Sales Source Data.</p> :
                                <Fragment>
                                    {salesSource.length > 0 ? (
                                        <ReactTable columns={excelColumns} data={salesSource} defaultPageSize={10} />
                                    ) : (
                                            <div className="no-data">No data found.</div>
                                        )}
                                </Fragment>
                            }
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
              <Col md={12} className="text-right mt-2">
                <Button
                  variant="danger"
                  type="button"
                  className="ml-3"
                   onClick={() => history.goBack()}
                >
                  <IoIosClose className="icon btn-icon" />
                  Cancel
                </Button>
              </Col>
            </Row>
            <Footer />
        </section>
    );

}

export default AptevoSalesSourcePage;